module.exports = __webpack_public_path__ + "img/bg.8bc2099f.png";